module.exports = __webpack_public_path__ + "img/HT01082-02.4fe28e12.jpg";